import * as React from "react";
import { prepareMarket, prepareEmptyMarket } from "../../../../../../helpers";
import { renderMiniBetButtonsRegular } from "../RenderMethods";
export const renderMiniMarketsRegular = (props, buttonsHolderClass, componentPrefix) => {
    const marketsInConfig = props.sport.config.markets;
    const market = prepareMarket(props.markets, marketsInConfig || [], props.event.isLive);
    const emptyMarket = prepareEmptyMarket(props.event.id, marketsInConfig[0].template, 0);
    return (React.createElement("div", { key: `${componentPrefix}__buttons-holder__${props.event.id}`, className: `rj-ev-list__${componentPrefix}__buttons-holder ${buttonsHolderClass}`, "data-uat": `div-ev-list-${componentPrefix}-buttons-holder` }, market
        ? renderMiniBetButtonsRegular(props, market, componentPrefix)
        : renderMiniBetButtonsRegular(props, emptyMarket, componentPrefix)));
};
//# sourceMappingURL=renderMiniMarketsRegular.js.map